<div class="page-wrapper">
  <!-- Metrics Header -->
  <go-app-metrics *ngIf="showMetrics" [__source]="__source"
    [class.hidden]="isMobilePotrait && (selectedView === 'calendar' || showRightPane)"></go-app-metrics>

  <!-- Main Content Area -->
  <div class="content-pane" [ngClass]="showRightPane ? 'preview-active' : 'preview-inactive'">
    <!-- Mobile Portrait View -->
    <ng-container *ngIf="isMobilePotrait; else desktopLayout">
      <div class="left-pane" [class.hidden]="showRightPaneOnly">
        <div class="left-pane-content">
          <ng-container [ngSwitch]="selectedView">
            <go-app-activities (newActivityOpened)="newActivityOpened = $event" (activityOpenedFromActivities)="onActivityOpenedFromActivities($event)" *ngSwitchCase="'calendar'"></go-app-activities>
            <go-app-todo *ngSwitchCase="'dashboard'"></go-app-todo>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="right-pane" [style]="showRightPaneOnly ? {width: '100%'} : {}">
      <ion-nav #activitiespagerightpane class="go-app-home-nav-pane" (ionNavDidChange)="onNavDidChange()" />
    </div>

    <!-- Desktop / Tablet View -->
    <ng-template #desktopLayout>
      <div class="left-pane" [class.hidden]="showRightPaneOnly || (uiShowRightPane && activityOpenedFrom === 'todo')">
        <div class="left-pane-content">
          <go-app-activities (newActivityOpened)="newActivityOpened = $event" (activityOpenedFromActivities)="onActivityOpenedFromActivities($event)"></go-app-activities>
        </div>
      </div>
      <div class="todo-pane"
        [class.hidden]="showRightPaneOnly || (uiShowRightPane && activityOpenedFrom === 'activities')">
        <go-app-todo (activityOpenedFromTodo)="onActivityOpenedFromTodo()"></go-app-todo>
      </div>
      <div class="arrow-indicator" *ngIf="uiShowRightPane && !showRightPaneOnly"></div>
    </ng-template>
  </div>
  <go-app-customers-pane [rightPaneVisible]="showRightPane" *ngIf="!isMobilePotrait"></go-app-customers-pane>
</div>